import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as reviewSlice from "../../../../redux/slices/reviewSlice";
import * as paymentSlice from "../../../../redux/slices/paymentSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import moment from "moment";

const PaymentHistory = () => {
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [locationId, setLocationId] = useState();
  const { locationData } = useSelector((state) => state.locationSlice);
  const navigate = useNavigate();
  const { allPickupPoints, allTopics, defaultReview, allPayments, loading } =
    useSelector((state) => state.paymentSlice);
  const [sortNumber, setSortNumber] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [previewImage, setPreviewImage] = useState();

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);
  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(paymentSlice.getPaymentHistory());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Payment Id",
      selector: (row) => row?.razorpay_payment_id || "-",
      sortable: true,
    },
    {
      name: "Payment Date",
      selector: (row) => moment(row.created_at)?.format("DD-MM-YY") || "-",
      sortable: true,
    },
     
    {
      name: "Amount",
      selector: (row) => row?.amount || "-",
      sortable: true,
    },
    {
      name: "Currency",
      selector: (row) => row?.currency || "-",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div
            className="view_more"
            onClick={() => {
              navigate("/payment-details", { state: { paymentData: row } });
            }}
          >
            <ViewMoreBtn />
          </div>
        </div>
      ),
    },
  ];

  const handleUpdate = async (event) => {
    event.preventDefault();
    await dispatch(reviewSlice.updateDefaultReview(locationId, form));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(reviewSlice.getDefaultReview());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form?.topic) {
      toast("Enter topic name please");
      return;
    }
    // await dispatch(faqChatSlice.storeTopic(form, setForm));
    setShowAddTempleModal(false);
    dispatch(reviewSlice.getDefaultReview());
  };
  console.log(allPayments, "allPayments");
  return (
    <>
      <h5 className="mb-4">Payment History</h5>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allPayments?.length && allPayments) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update" : "Add"} Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Rating</Form.Label>
              <Form.Control
                type="text"
                value={form?.rating}
                disabled={true}
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formReview" className="mb-3">
              <Form.Label>Feedback</Form.Label>
              <Form.Control
                as="textarea" // Switches to a textarea
                rows={5} // Adjust rows to display more content by default
                value={form?.review}
                disabled={true} // Keeps the field read-only
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>

            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Change Status</Form.Label>
              <Form.Select
                value={form?.status} // Assuming `form.status` holds the selected status
                onChange={(e) => setForm({ ...form, status: e.target.value })} // Update form state on change
                required // Optional: If you want to make this field mandatory
              >
                <option value="">Select Status</option>{" "}
                {/* Placeholder option */}
                <option value="1">Pending</option>
                <option value="2">Approved</option>
                <option value="3">Reject</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>

          <Button variant="primary" type="submit" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentHistory;
